import { DialogComponent } from '@theme/dialog';

/**
 * Configurable PDP modal opened by elements matching a merchant-defined CSS class.
 *
 * @extends {DialogComponent}
 */
class PdpCustomModalComponent extends DialogComponent {
  /** @type {(event: MouseEvent) => void | undefined} */
  #clickHandler;

  connectedCallback() {
    super.connectedCallback();

    const triggerClass = this.dataset.triggerClass?.trim();
    if (!triggerClass) return;

    const productRoot = this.closest('.product-information');

    this.#clickHandler = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest(`.${CSS.escape(triggerClass)}`);
      if (!trigger) return;
      if (trigger.closest('pdp-custom-modal-component') === this) return;
      if (productRoot && !productRoot.contains(trigger)) return;

      if (trigger instanceof HTMLAnchorElement) {
        event.preventDefault();
      }

      this.showDialog();
    };

    document.addEventListener('click', this.#clickHandler);
  }

  disconnectedCallback() {
    if (this.#clickHandler) {
      document.removeEventListener('click', this.#clickHandler);
    }
    super.disconnectedCallback();
  }
}

if (!customElements.get('pdp-custom-modal-component')) {
  customElements.define('pdp-custom-modal-component', PdpCustomModalComponent);
}
